// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-div {
  padding: 12px;
  border-radius: 12px;
  display: flex;
  gap: 10px;
}
.status-div .status {
  font-size: 14px;
}

.warning {
  border: 1px solid #feefed;
  background-color: #feefed;
  width: fit-content;
  display: flex;
  align-items: center;
  margin: 5px;
}

.sucess {
  background-color: #e6f7ef;
  color: #00aa74;
  width: fit-content;
  display: flex;
  align-items: center;
  margin: 5px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/StatusComponent/style.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AAAJ;AACI;EACI,eAAA;AACR;;AAEA;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;;AACA;EACI,yBCjBY;EDkBZ,cCnBY;EDoBZ,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAEJ","sourcesContent":["@import '../../../Styles/sass/variables';\n.status-div {\n    padding: 12px;\n    border-radius: 12px;\n    display: flex;\n    gap: 10px;\n    .status {\n        font-size: 14px;\n    }\n}\n.warning {\n    border: 1px solid #feefed;\n    background-color: #feefed;\n    width: fit-content;\n    display: flex;\n    align-items: center;\n    margin: 5px;\n}\n.sucess {\n    background-color: $primary_light;\n    color: $primary_green;\n    width: fit-content;\n    display: flex;\n    align-items: center;\n    margin: 5px;\n}\n","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
